import { SxProps, Theme } from '@mui/material';

const styles: SxProps<Theme> = (theme) => ({
  opacity: 0.5,
  transition: theme.transitions.hover,

  '&:hover': {
    opacity: 1,
    transition: theme.transitions.hover,
  },
});

export default styles;
